import { UTILS__VALIDATOR__is_value } from 'utils/validator'

import { MAIN_SERVER } from './instance'

export const GET_PAYMENTS_HISTORY = async obj => {
    try {
        const params = {}

        if (UTILS__VALIDATOR__is_value(obj.per_page)) {
            params.size = obj.per_page
        }
        if (UTILS__VALIDATOR__is_value(obj.offset_pages)) {
            params.page = obj.offset_pages
        }
        if (UTILS__VALIDATOR__is_value(obj.sort)) {
            params.sort = obj.sort
        }

        return await MAIN_SERVER({
            method: 'get',
            url: `/payments`,
            params,
        })
    } catch (err) {
        throw err
    }
}

export const CREATE_ORDER = async ({ guid }) =>
    MAIN_SERVER({
        method: 'post',
        url: '/orders',
        headers: {
            'Content-Type': 'application/json',
        },
        data: {
            guid,
        },
    })

export const GET_ORDER = async ({ guid }) =>
    MAIN_SERVER({
        method: 'get',
        url: `/orders/${guid}`,
    })

export const GET_INVOICE = orderReference =>
    MAIN_SERVER({
        method: 'get',
        url: `/payments/invoice/${orderReference}/`,
    })

export const GET_PAYMENT_LINK = ({ productCode, couponCode = '' }) =>
    MAIN_SERVER({
        method: 'post',
        url: '/orders/generate-link',
        data: {
            productCode,
            couponCode,
        },
    })
